// extracted by mini-css-extract-plugin
export default {"BooksGrid":"BooksGrid_BooksGrid__iPMB7","BooksGrid__Grid":"BooksGrid_BooksGrid__Grid__4-bpB","BooksGrid__Ad":"BooksGrid_BooksGrid__Ad__hCSfh"};